import { BaseDataModel } from "@domain/CRM/BaseDataModel";

/**
 * A master Dropoff instantiated as an ordered stop on one shift (Airtable "Shift Dropoffs"
 * junction record). `order` shares the shift's mixed run-sequence with the jobs'
 * `Job.order`; `jobIds` records which jobs' samples this stop receives.
 */
export class ShiftDropoff extends BaseDataModel {
	dropoffId?: string;
	shiftId?: string;
	jobIds!: string[];
	order?: number;
	/** Read-only lookups from the linked Dropoff / Shift. Prefer joining the master
	 *  Dropoff via `dropoffId` for display — the offline fake doesn't compute lookups
	 *  on freshly created stops. */
	name!: string;
	latitude?: number;
	longitude?: number;
	schedDate?: Date;
}
